import { render, staticRenderFns } from "./IconAtSymbolSolid.vue?vue&type=template&id=22d7a814"
import script from "./IconAtSymbolSolid.vue?vue&type=script&lang=js"
export * from "./IconAtSymbolSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports